import styles from './index.styl';

function AdPlaceholder() {
  return (
    <div className={styles.placeholder}>
      <div className={styles.content}>
        <div className='text'>
          Слайд, который <br />
          я выбрал вместо рекламы.
        </div>
        <div className={styles.emoji}>😑</div>
      </div>
    </div>
  );
}

export default AdPlaceholder;
